import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL_NEW } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';
import { StrandedSessionsBoResponse } from '@utils/types/back-office/stranded-sessions';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

export const useGetStrandedSessionBo = () => {
  const { t } = useTranslation();
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sortField = (searchParams.sort as string | undefined) || undefined;
  const sortDirection =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;

  const qString = (searchParams.q as string | undefined) || undefined;

  const fetchStranded = async () => {
    const { strandedSessions } = GET_URL_NEW({
      offset,
      limit,
      q: qString,
      sort: sortField,
      direction: sortDirection
    });

    const { data } =
      await Axios.get<StrandedSessionsBoResponse>(strandedSessions);
    return data;
  };

  return useQuery<StrandedSessionsBoResponse, AxiosError<BaseError>>(
    ['strandedSessions', offset, limit, qString, sortField, sortDirection],
    fetchStranded,
    {
      useErrorBoundary: false,
      keepPreviousData: true,
      onError: (error: AxiosError<BaseError>) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const d = error.response?.data as any;
        const msg =
          d?.error_description ||
          d?.detail ||
          d?.error ||
          d?.message ||
          t('an-error-occurred');
        toast.error(String(msg));
      }
    }
  );
};
